import { useCallback, useState } from "react";
import { NavLink } from "react-router-dom";
// import Social from "./social";
import StakeIcon from "../../../assets/icons/stake.svg";
import BondIcon from "../../../assets/icons/bond.svg";
import DiamondbankIcon from "../../../assets/icons/diamondbankdao-nav-header.png";
import BuyIcon from "../../../assets/icons/buy.svg";
import ProIcon from "../../../assets/icons/pro.svg";
import RewardIcon from "../../../assets/icons/reward.svg";
import ChartIcon from "../../../assets/icons/chart.svg";
import LaunchpadIcon from "../../../assets/icons/launchpad.svg";
import InfoIcon from "../../../assets/icons/info.svg";
import AirdropIcon from "../../../assets/icons/airdrop.svg";
import DashboardIcon from "../../../assets/icons/dashboard.svg";
import { trim, shorten } from "../../../helpers";
import { useAddress } from "../../../hooks";
import useBonds from "../../../hooks/bonds";
import { Link } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import "./drawer-content.scss";
import DocsIcon from "../../../assets/icons/docs.svg";
import GlobeIcon from "../../../assets/icons/wonderglobe.svg";
import classnames from "classnames";

function NavContent() {
    const [isActive] = useState();
    const address = useAddress();
    const { bonds } = useBonds();

    const checkPage = useCallback((location: any, page: string): boolean => {
        const currentPath = location.pathname.replace("/", "");
        if (currentPath.indexOf("dashboard") >= 0 && page === "dashboard") {
            return true;
        }
        if (currentPath.indexOf("stake") >= 0 && page === "stake") {
            return true;
        }
        if (currentPath.indexOf("mints") >= 0 && page === "mints") {
            return true;
        }
        if (currentPath.indexOf("calculator") >= 0 && page === "calculator") {
            return true;
        }
        return false;
    }, []);

    return (
        <div className="dapp-sidebar">
            <div className="branding-header">
                <Link href="https://db.cash" target="_blank">
                    <img alt="" src={DiamondbankIcon} style={{ maxWidth: 200 }} />
                </Link>

                {address && (
                    <div className="wallet-link">
                        <Link href={`https://cchain.explorer.avax.network/address/${address}`} target="_blank">
                            <p>{shorten(address)}</p>
                        </Link>
                    </div>
                )}
            </div>

            <div className="dapp-menu-links">
                <div className="dapp-nav">
                    <Link
                        component={NavLink}
                        to="/dashboard"
                        isActive={(match: any, location: any) => {
                            return checkPage(location, "dashboard");
                        }}
                        className={classnames("button-dapp-menu", { active: isActive })}
                    >
                        <div className="dapp-menu-item">
                            <img alt="" src={DashboardIcon} />
                            <p>Bank Board</p>
                        </div>
                    </Link>

                    <Link
                        component={NavLink}
                        to="/stake"
                        isActive={(match: any, location: any) => {
                            return checkPage(location, "stake");
                        }}
                        className={classnames("button-dapp-menu", { active: isActive })}
                    >
                        <div className="dapp-menu-item">
                            <img alt="" src={StakeIcon} />
                            <p>Stake</p>
                        </div>
                    </Link>

                    <Link
                        component={NavLink}
                        id="bond-nav"
                        to="/mints"
                        isActive={(match: any, location: any) => {
                            return checkPage(location, "mints");
                        }}
                        className={classnames("button-dapp-menu", { active: isActive })}
                    >
                        <div className="dapp-menu-item">
                            <img alt="" src={BondIcon} />
                            <p>Bond</p>
                        </div>
                    </Link>

                    <div className="bond-discounts">
                        <p>Bond discounts</p>
                        {bonds.map((bond, i) => (
                            <Link component={NavLink} to={`/mints/${bond.name}`} key={i} className={"bond"}>
                                {!bond.bondDiscount ? (
                                    <Skeleton variant="text" width={"150px"} />
                                ) : (
                                    <p>
                                        {bond.displayName}
                                        <span className="bond-pair-roi">{bond.bondDiscount && trim(bond.bondDiscount * 100, 2)}%</span>
                                    </p>
                                )}
                            </Link>
                        ))}
                    </div>

                    <Link
                        href={"https://traderjoexyz.com/#/trade?inputCurrency=&outputCurrency=0x3B760B2527a4C2bb5E0F2B9e7BC77744adE2484E"}
                        target="_blank"
                        className={"button-dapp-menu"}
                    >
                        <div className="dapp-menu-item">
                            <img alt="" src={BuyIcon} />
                            <p>Buy</p>
                        </div>
                    </Link>

                    <Link
                        component={NavLink}
                        to="/calculator"
                        isActive={(match: any, location: any) => {
                            return checkPage(location, "calculator");
                        }}
                        className={classnames("button-dapp-menu", { active: isActive })}
                    >
                        <div className="dapp-menu-item">
                            <img alt="" src={InfoIcon} />
                            <p>Diamond Appraisal</p>
                        </div>
                    </Link>

                    <Link
                        component={NavLink}
                        to="/mining"
                        isActive={(match: any, location: any) => {
                            return checkPage(location, "dashboard");
                        }}
                        className={classnames("button-dapp-menu", { active: isActive })}
                    >
                        <div className="dapp-menu-item">
                            <img alt="" src={RewardIcon} />
                            <p>Diamond Nodes</p>
                        </div>
                    </Link>

                    <Link
                        component={NavLink}
                        to="/dashboard"
                        isActive={(match: any, location: any) => {
                            return checkPage(location, "dashboard");
                        }}
                        className={classnames("button-dapp-menu", { active: isActive })}
                    >
                        <div className="dapp-menu-item">
                            <img alt="" src={AirdropIcon} />
                            <p>Airdrops</p>
                        </div>
                    </Link>

                    <Link href="https://diamond-bank-dao.gitbook.io/welcome-to-gitbook/" target="_blank" className={"button-dapp-menu"}>
                        <div className="dapp-menu-item">
                            <img alt="" src={DocsIcon} />
                            <p>Docs</p>
                        </div>
                    </Link>

                    {/* <Link href="https://diamondbankdao.gitbook.io/diamondbankdao/" target="_blank" className={"button-dapp-menu"}>
                        <div className="dapp-menu-item">
                            <img alt="" src={ChartIcon} />
                            <p>Charts</p>
                        </div>
                    </Link> */}

                    <Link
                        component={NavLink}
                        to="/dashboard"
                        isActive={(match: any, location: any) => {
                            return checkPage(location, "dashboard");
                        }}
                        className={classnames("button-dapp-menu", { active: isActive })}
                    >
                        <div className="dapp-menu-item">
                            <img alt="" src={ProIcon} />
                            <p>
                                DB Pro <span>coming soon</span>
                            </p>
                        </div>
                    </Link>

                    <Link
                        component={NavLink}
                        to="/dashboard"
                        isActive={(match: any, location: any) => {
                            return checkPage(location, "dashboard");
                        }}
                        className={classnames("button-dapp-menu", { active: isActive })}
                    >
                        <div className="dapp-menu-item">
                            <img alt="" src={LaunchpadIcon} />
                            <p>
                                Diamond Pad <span>coming soon</span>
                            </p>
                        </div>
                    </Link>
                </div>
            </div>
            {/* <div className="dapp-menu-doc-link">
                <Link href="https://legacy.diamondbankdao.money/" target="_blank">
                    <p>Legacy website</p>
                </Link>
            </div> */}
            {/* <Social /> */}
        </div>
    );
}

export default NavContent;
